<script>
import DashboardDatabase from "@/DashboardDatabase.vue";
import DashboardOutageLate from "@/DashboardOutageLate.vue";
import DashboardOutageLateMonth from "@/DashboardOutageLateMonth.vue";
import DashboardPowerPerLamptype from "@/DashboardPowerPerLamptype.vue";
import DashboardTotalEnergyPerYear from "@/DashboardTotalEnergyPerYear.vue";
// import DashboardOpenWorkOrders from "@/DashboardOpenWorkOrders.vue";
import DashboardOpenNetworkOutages from "@/DashboardOpenNetworkOutages.vue";

export default {
  components: {
    DashboardDatabase,
    DashboardOutageLate,
    DashboardOutageLateMonth,
    DashboardPowerPerLamptype,
    DashboardTotalEnergyPerYear,
    DashboardOpenNetworkOutages
  },
  async mounted() {
    await this.getClientOptions();
  },
  data() {
    return {
      clients_loading: true,
      organisations_loading: false,
      client_id: 0,
      organisation_id: 0,
      client_options: [],
      organisation_options: [],
      dashboardCharts: [
        {
          title: 'Database',
          component: 'DashboardDatabase'
        },
        {
          title: 'Open storingen te laat',
          component: 'DashboardOutageLate'
        },
        {
          title: 'Storingen te laat per maand',
          component: 'DashboardOutageLateMonth'
        },
        {
          title: 'Vermogen per lamptype',
          component: 'DashboardPowerPerLamptype'
        },
        {
          title: 'Totale energieverbruik per jaar',
          component: 'DashboardTotalEnergyPerYear'
        },
        // {
        //   title: 'Werkorders open',
        //   component: 'DashboardOpenWorkOrders'
        // },
        {
          title: 'Netwerk storingen open',
          component: 'DashboardOpenNetworkOutages'
        }
      ],
    }
  },
  watch: {
    client_id: {
      immediate: true,
      handler(newVal) {
        this.getOrganisationOptions(newVal);
      }
    }
  },
  methods: {
    async getClientOptions() {
      this.clients_loading = true;
      try {
        const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/dashboard/client-options', {
          credentials: 'include'
        });

        this.client_options = await response.json();

        if (this.client_id === 0) {
          this.client_id = Number(this.client_options[0].value);
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        this.clients_loading = false;
      }
    },
    async getOrganisationOptions(client_id) {
      this.organisations_loading = true;
      try {
        const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/dashboard/organisation-options/' + client_id, {
          credentials: 'include'
        });

        this.organisation_options = await response.json();
      } catch (error) {
        console.error('Error:', error);
      } finally {
        this.organisations_loading = false;
      }
    },
    async submitForm() {
      console.log('submitForm');
    }
  },
}

</script>

<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Dashboard instellingen
          </v-card-title>
          <v-card-text>
            <form>
              <div>
                <label for="client_id">Beheerder</label>
                <v-select
                  :disabled="client_options.length === 0"
                  :loading="this.clients_loading"
                  id="client_id"
                  label="Select"
                  v-model="client_id"
                  :items="client_options"
                  item-title="text"
                  item-value="value"
                ></v-select>

                <label for="organisation_id">Organisatie</label>
                <v-select
                  :disabled="organisation_options.length === 0"
                  :loading="organisations_loading"
                  id="organisation_id"
                  label="Select"
                  v-model="organisation_id"
                  :items="organisation_options"
                  item-title="text"
                  item-value="value"
                ></v-select>
              </div>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        v-for="(item, index) in dashboardCharts"
        :key="index"
        cols="12"
        md="6"
      >
        <v-card v-if="client_id !== 0">
          <v-card-title>
            {{ item.title }}
          </v-card-title>
          <v-card-text>
            <component
              :is="item.component"
              :client_id="client_id"
              :organisation_id="organisation_id"
              />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">

</style>
